var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "mb-2" }, [
        _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { md: "5", sm: "12", cols: "12" } },
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    { staticClass: "mx-0 w-full" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "pl-0", attrs: { md: "6", sm: "6" } },
                        [_c("label", [_vm._v("Project")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "pr-0 text-right",
                          attrs: { md: "6", sm: "6" }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "select-label mr-2",
                              staticStyle: { color: "#4a90e2" }
                            },
                            [_vm._v("\n              Select All\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "select-label",
                              staticStyle: { color: "#4a90e2" }
                            },
                            [
                              _vm._v(
                                "\n              Unselect All\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("j-multi-select", {
                    attrs: {
                      disabled: true,
                      placeholder: "Select Project",
                      "value-format": "object",
                      label: "name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "5", sm: "12", cols: "12" } },
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6", md: "6" } },
                                [
                                  _c("label", { attrs: { for: "startDate" } }, [
                                    _vm._v("From")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-datepicker", {
                                    attrs: {
                                      disabled: true,
                                      format: "MMM dd, yyyy",
                                      placeholder: "Ex. Jan 01, 2019"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6", md: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "endDate" } },
                                        [_vm._v("To")]
                                      ),
                                      _vm._v(" "),
                                      _c("j-datepicker", {
                                        attrs: {
                                          disabled: true,
                                          format: "MMM dd, yyyy",
                                          placeholder: "Ex. Des 31, 2019"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center ",
              attrs: { md: "2", sm: "12", cols: "3" }
            },
            [
              _c(
                "b-form-group",
                { staticClass: "text-left search-form" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "10", md: "10" } },
                        [
                          _c(
                            "b-button",
                            { staticClass: "btn blue d-flex items-center" },
                            [
                              _c("i", {
                                staticClass: "fa fa-search bold mr-1 mt-1"
                              }),
                              _vm._v(" Search\n            ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "columns mt-3" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          _vm._l(_vm.columns, function(column) {
            return _c(
              "div",
              { key: column, staticClass: "column" },
              [
                _c(
                  "div",
                  {
                    staticClass: "header-list",
                    staticStyle: { cursor: "default !important" }
                  },
                  [
                    _c("div", { staticClass: "column-name" }, [
                      _vm._v(_vm._s(column))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(4, function(index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "column-preview",
                      class: { "bg-gray": index === 2 || index === 4 },
                      staticStyle: { cursor: "default !important" }
                    },
                    [_c("div", { staticClass: "content-preview" })]
                  )
                })
              ],
              2
            )
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-871ef604", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-871ef604","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyAttendanceMyLog.vue
// module id = null
// module chunks = 